import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BillCycleTypeValues, ChargeType, RatePlanType } from 'src/app/app.data';
import { ChargeRule } from 'src/app/_shared/models/rules.model';
import { ChargePrepaidRulesComponent } from './prepaid-rules/charge-prepaid-rules.component';
import { ChargeLoyaltyRulesComponent } from './loyalty-rules/charge-loyalty-rules.component';
import { FormChargeCutOffRulesComponent } from './cutoff-rules/charge-cutoff-rules.component';
import { PermissionManagerService } from 'src/app/_shared/services/permission/permissions.service';

@Component({
  selector: 'form-charge-rules-component',
  templateUrl: './charge-rules.component.html'
})

export class FormChargeRulesComponent implements OnInit, OnChanges {
  collectionOfChargesRule: Array<ChargeRule> = [];
  cutOffSetting:any = null;
  usageBasedRules:any = {};
  giftCharge = false;
  hasGiftRestriction = false;

  ratePlanTypeSelected : string = null;

  @ViewChild(ChargeLoyaltyRulesComponent) _chargeLoyaltyRulesComponent: ChargeLoyaltyRulesComponent;
  loyaltyRulesFormErrors: boolean = false;

  @ViewChild(ChargePrepaidRulesComponent) _chargePrepaidRulesComponent: ChargePrepaidRulesComponent;
  chargePrepaidRulesFormErrors: boolean = false;

  @ViewChild(FormChargeCutOffRulesComponent) _chargeCutOffRulesComponent: FormChargeCutOffRulesComponent;
  cutOffRulesFormErrors: boolean = false;

  @Input() _data: any;
  @Input() _ratePlanType = RatePlanType;
  @Input() _selectedChargeType: ChargeType = ChargeType.oneTimeCharge;
  @Input() _selectedBillCycleTypeValue: BillCycleTypeValues = BillCycleTypeValues.subscriptionStartDay;

  @Output() _emitChargesRules: EventEmitter<any> = new EventEmitter<any>();
  @Output() _emitFormErrors: EventEmitter<any> = new EventEmitter<any>();
  @Output() _emitChangeChargeRules: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private permissionS: PermissionManagerService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case '_selectedChargeType': {
            this._selectedChargeType = changes._selectedChargeType.currentValue;
            break;
          }
          case '_selectedBillCycleTypeValue': {
            this._selectedBillCycleTypeValue = changes._selectedBillCycleTypeValue.currentValue;
            break;
          }
        }
      }
    }
  }

  ngOnInit(): void {
    this.ratePlanTypeSelected = this.data.ratePlanTypeSelected;
    this.giftCharge = this.data.isGift;

    this.hasGiftRestriction = this.permissionS.isRestricted('feature_setasgift|enabled|SCOPE_SET_VALUE');
    if(this.hasGiftRestriction){
      this.giftCharge = false;
    }
  }

  onGetCutOffRules(_bodyParams: any) {
    this.cutOffSetting = _bodyParams;
  }

  onGetLoyaltyRules(_bodyParams: any) {
    this.loyaltyRulesFormErrors = false;
    this.collectionOfChargesRule.push(..._bodyParams);
  }

  onChangeUsageBasedRules(_bodyParams: any) {
    this.usageBasedRules = {..._bodyParams};
    this._data.usageBased = this.usageBasedRules.usageBased
    this._emitChangeChargeRules.emit();
  }

  onGetCutOffRulesFormErrors(anyError: boolean) {
    this.cutOffRulesFormErrors = anyError;
  }

  onGetLoyaltyRulesFormErrors(anyError: boolean) {
    this.loyaltyRulesFormErrors = anyError;
  }

  onGetPrepaidRules(_bodyParams: any) {
    this.chargePrepaidRulesFormErrors = false;
    this.collectionOfChargesRule.push(..._bodyParams);
  }

  onGetPrepaidRulesFormErrors(anyError: boolean) {
    this.chargePrepaidRulesFormErrors = anyError;
  }

  setBodyParams(): void {
    this._chargeLoyaltyRulesComponent.setBodyParams();

    if(this.ratePlanTypeSelected == RatePlanType.prepaid ) {
      this._chargePrepaidRulesComponent.setBodyParams();
    }

    if(this._data.isProduct) {
      this._chargeCutOffRulesComponent.setBodyParams();
    }

    if (!this.loyaltyRulesFormErrors && !this.chargePrepaidRulesFormErrors && !this.cutOffRulesFormErrors) {

      const bodyToSend: any = {
        rules: []
      }

      bodyToSend.rules = this.collectionOfChargesRule;

      if(this._data.isProduct) {
        bodyToSend.cutOffType = this.cutOffSetting.cutOffType;
        bodyToSend.cutOffValue = this.cutOffSetting.cutOffValue;
      }

      bodyToSend.usageType = this.usageBasedRules.usageType;
      bodyToSend.isGift = this.giftCharge;

      this._emitChargesRules.emit(bodyToSend);
    }
    else {
      this._emitFormErrors.emit(true);
    }
  }

}
